module.exports = __webpack_public_path__ + "img/personal-info.8b5c9a4f.svg";